import { IconButton } from "@mui/material";
import { type FC } from "react";

import type { IAggregatedEvent } from "~/types/event";

import * as Styled from "./ActionButtons.styles";
import { useActionButtons } from "./useActionButtons";

export interface ActionButtonsProps {
  event: IAggregatedEvent;
}

export const ActionButtons: FC<ActionButtonsProps> = ({ event }) => {
  const { actionItems } = useActionButtons(event);

  return (
    <Styled.Root>
      {actionItems.map((item) => {
        const { Icon } = item;
        return (
          <IconButton
            key={item.label}
            aria-label={item.label}
            onClick={item.onClick}
          >
            <Icon fontSize="small" color={item.color} />
          </IconButton>
        );
      })}
    </Styled.Root>
  );
};
